import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleField } from '../../../components';
import { Field } from 'formik';

interface LanguageToolFormProps {};

function LanguageToolForm(props: LanguageToolFormProps) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 space-x-0 lg:space-x-12">
            <div className="flex-1">
                <h2 className="mt-4 mb-1 text-base font-semibold leadin text-lg text-gray-900 dark:text-gray-100">
                    {t('settings.languagetool')}
                </h2>
                <div className="mt-5">
                    <div className="mt-2 flex space-between">
                        <label htmlFor="enable" className="flex-1 text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                            {t('settings.enable_languagetool')}
                        </label>
                        <ToggleField name="languagetool.enabled" className="inline"/>
                    </div>
                </div>
                <div className="mt-5">
                    <label htmlFor="api_url" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                        {t('settings.languagetool_api_url')}
                    </label>
                    <div className="mt-2">
                        <Field
                            type="text"
                            name="languagetool.api_url"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="https://proofread.netoxygen.ch"
                        />
                    </div>
                </div>
                <div className="mt-5">
                    <label htmlFor="default_language" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                        {t('settings.languagetool_default_language')}
                    </label>
                    <div className="mt-2">
                        <Field
                            type="text"
                            name="languagetool.default_language"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="auto"
                        />
                    </div>
                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        {t('settings.languagetool_default_language_help')}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default LanguageToolForm;
